import { KeyLabel } from '../../../../shared/domain/key-label.model';

export enum StatusChange {
  ACTIVE_TO_INACTIVE = 'ACTIVE_TO_INACTIVE',
  READY_TO_ACTIVE = 'READY_TO_ACTIVE',
  DRAFT_TO_READY = 'DRAFT_TO_READY'
}

export enum StatusChangeLabels {
  ACTIVE_TO_INACTIVE = 'ACTIVE TO INACTIVE',
  READY_TO_ACTIVE = 'READY TO ACTIVE',
  DRAFT_TO_READY = 'DRAFT TO READY'
}

export const StatusChangeKL = () =>
  (Object.keys(StatusChange).map(key => new KeyLabel<StatusChange>(<StatusChange>key, StatusChangeLabels[key])));

